<template>
  <div class="lg:px-70px pb-10">
    <BaseTextarea class="mb-8"
                  :label="$t('labelTextarea')"
                  v-model="$v.message.$model"
                  :class="{'--error':$v.message.$error}"
                  @keydown.shift.enter.prevent="send">
      <template v-slot:errors>
        <div class="error" v-if="!$v.message.required">{{ $t('errors.required') }}</div>
        <div class="error" v-if="!$v.message.minLength">{{ $t('messageMinLength') }}</div>
      </template>
    </BaseTextarea>
    <div class="flex">
      <BaseButton theme="red" class="flex-none lg:w-91"
                  :loading="submitted"
                  @click="send">
        {{ $t('labelBtn') }}
      </BaseButton>
      <FileUpload class="ml-4 lg:ml-12"
                  v-model="attachments"
                  :accept="['zip', 'rar', 'jpg', 'jpeg', 'png', 'gif', 'pdf', 'csv', 'xls', 'xlsx']"
                  ref="files"/>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {minLength, required} from "vuelidate/lib/validators";
import BaseTextarea from "@/components/UI/BaseTextarea";
import BaseButton from "@/components/UI/BaseButton";
import IconAttach from "@/components/icons/IconAttach";
import FileUpload from "@/components/common/FileUpload";

export default {
  name: "TicketsChatMessage",
  components: {FileUpload, IconAttach, BaseButton, BaseTextarea},
  data() {
    return {
      message: '',
      attachments: [],
      submitted: false
    }
  },
  validations: {
    message: {
      required,
      minLength: minLength(5)
    },
  },
  methods: {
    ...mapActions('cabinet/tickets', ['sendMessage', 'updateMessages']),
    async send() {
      if (this.submitted) return;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let formData = new FormData();
        formData.append('message', this.message);
        let attachments = this.attachments;
        if (attachments.length > 5) {
          this.$toasted.error(this.$t('availableFilesError'))
          return;
        }
        if (!!attachments) {
          attachments.forEach(file => {
            formData.append('files[]', file);
          });
        }
        try {
          this.submitted = true;
          const res = await this.sendMessage(formData);
          if (res.body.success) {
            this.updateMessages(res.body.data);
            this.message = '';
            this.attachments = [];
            this.$v.$reset();
            setTimeout(() => {
              this.$emit('scrollChat')
            }, 200)
          } else {
            Object.values(res.body.message).forEach((item) => {
              if (typeof item === 'string') this.$toasted.error(item, {duration: 5000})
            })
            console.error(res)
          }
        } catch (e) {
          console.log(e)
          this.$toasted.error(this.$t('errors.response'))
        } finally {
          this.submitted = false;
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        labelTextarea: 'Message...',
        labelBtn: 'Send',
        messageMinLength: 'The message must be at least 5 characters long',
        availableFilesError: 'Only 5 files available for download'
      },
      ru: {
        labelTextarea: 'Текст сообщения...',
        labelBtn: 'Отправить',
        messageMinLength: 'Сообщение должно содержать минимум 5 символов',
        availableFilesError: 'Доступно для загрузки только 5 файлов'
      },
    }
  }
}
</script>